import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroupsProps } from "./ButtonGroups.types";
import { ButtonDigited } from "../../components/Button/Button.variants";

export const ButtonGroups: React.FC<ButtonGroupsProps> = ({ onClickCancel, onClickConfirm }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={ {
        backgroundColor: theme.customColors.backgroundPrimary,
        bottom: 0,
        boxShadow: `0 3rem 0 0 ${theme.customColors.backgroundPrimary}`,
        display: "flex",
        flex: "1 1",
        flexDirection: "row",
        gap: 1,
        justifyContent: "flex-end",
        pb: 1,
        position: "sticky",
        pt: 2,
        width: "100%",
        zIndex: 2
      } }
    >
      <ButtonDigited
        id="cancel"
        typology="secondary"
        onClick={ onClickCancel }
      >
        { t("annul") }
      </ButtonDigited>
      <ButtonDigited
        id={ "confirm" }
        typology="primary"
        onClick={ onClickConfirm }
      >
        { t("confirm") }
      </ButtonDigited>
    </Box>
  );
};
